<div class="row">
    <div class="col-sm-12" style="text-align: right;">
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
   
</div>
<iframe width="{{widthIframe}}" height="{{heightIframe}}" [src]="urlSafe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>

